var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEditMode)?_c('draggable',{staticClass:"row",attrs:{"value":_vm.charts,"group":"dashboard","tag":"div"},on:{"input":function($event){return _vm.$emit('update:charts', $event)}}},[_vm._t("default")],2):_c('v-row',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }